import { render, staticRenderFns } from "./LeakDetailPage.vue?vue&type=template&id=94e5c0b6&scoped=true"
import script from "./LeakDetailPage.vue?vue&type=script&lang=ts"
export * from "./LeakDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./LeakDetailPage.vue?vue&type=style&index=0&id=94e5c0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5c0b6",
  null
  
)

export default component.exports